// extracted by mini-css-extract-plugin
export var wordContainer = "_oc-0";